import { Outlet } from "react-router-dom"
import ClientHeader from "./ClientHeader"
import ClientFooter from "./CleintFooter"
import "./style/MainLayout.scss"

const MainLayout = () => {
  return (
    <div className="main-layout">
      <ClientHeader />
      <main className="main-content">
        <Outlet />
      </main>
      <ClientFooter />
    </div>
  )
}

export default MainLayout
